module.exports = __webpack_public_path__ + "static/media/tuberia-conduit-pared-gruesa.6baa1b13.jpg";